import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | Cultiva Botanics` : "Cultiva Botanics — Pure Plants. Better Living.";
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setOg = (prop, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setOg("og:title", title || "Cultiva Botanics");
    setOg("og:description", description);
    setOg("og:type", "website");
  }, [title, description]);
  return null;
}
